import { useEffect } from 'react';
import { setPageSEO } from '../utils/seo';

// 自定义 Hook 用于管理页面 SEO
export const useSEO = (pageKey, customTitle = null, customDescription = null, customKeywords = null) => {
  useEffect(() => {
    if (customTitle || customDescription || customKeywords) {
      // 如果有自定义的 SEO 信息，使用自定义的
      if (customTitle) {
        document.title = customTitle.includes('希航留学') ? customTitle : `${customTitle} - 希航留学`;
      }
      
      if (customDescription) {
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', customDescription);
        }
      }
      
      if (customKeywords) {
        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) {
          metaKeywords.setAttribute('content', customKeywords);
        }
      }
    } else if (pageKey) {
      // 否则使用预定义的 SEO 配置
      setPageSEO(pageKey);
    }
  }, [pageKey, customTitle, customDescription, customKeywords]);
};
